export default {
    name: "interactiveBook",
    title: "Interactive Book",
    icon: require("./content-icon.svg"),
    category: "training"
}